var _circle, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpIcons(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 8,
    fill: "#2E7D32",
    fillOpacity: 0.1
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_261_85383)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.78776 3.09165L5.08791 5.90408C5.03162 5.96272 5 6.04224 5 6.12517C5 6.20809 5.03162 6.28762 5.08791 6.34626C5.1442 6.40489 5.22055 6.43784 5.30015 6.43784C5.37976 6.43784 5.4561 6.40489 5.51239 6.34626L7.70002 4.06702L7.70002 12.6875C7.70002 12.7704 7.73162 12.8499 7.78788 12.9085C7.84414 12.9671 7.92044 13 8 13C8.07956 13 8.15586 12.9671 8.21212 12.9085C8.26838 12.8499 8.29998 12.7704 8.29998 12.6875L8.29998 4.06702L10.4876 6.34626C10.5439 6.40489 10.6202 6.43784 10.6999 6.43784C10.7795 6.43784 10.8558 6.40489 10.9121 6.34626C10.9684 6.28762 11 6.20809 11 6.12517C11 6.04224 10.9684 5.96272 10.9121 5.90408L8.21224 3.09165C8.18438 3.0626 8.15129 3.03955 8.11488 3.02382C8.07846 3.00809 8.03942 3 8 3C7.96058 3 7.92154 3.00809 7.88512 3.02382C7.84871 3.03955 7.81562 3.0626 7.78776 3.09165Z",
    fill: "#2E7D32"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_261_85383"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 8,
    fill: "white",
    transform: "matrix(-4.37114e-08 1 1 4.37114e-08 4 3)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpIcons);
export default __webpack_public_path__ + "static/media/up-icons.ef9f1fe9b9cb66f2d604d18970b5fe6c.svg";
export { ForwardRef as ReactComponent };